<template>
    <div class="text-similar-ques-modal">
        <TitleBaseBox :title="data.title" :noButton="true" @close="close" class="text-similar-ques-box">
            <p v-if="data.word" class="text-editor-select-title">
                {{ wordLabel }}<span class="text-editor-select-text">{{ data.word }}</span>
            </p>
            <RelationQuesBar
                @initCurrPage="initCurrPage"
                @getBatchQuestionList="getLinkedQuestionList"
                :searchReset="searchReset"
                :applySkinType="'questionSelectorTableModal'"
                :currentLang="currentLang"
                :disabled="data.langDisabled"
            />
            <Table
                :curPage="curPage"
                :config="tableConfig"
                :dataset="dataSource"
                :total="standTotal"
                @columnClick="tableColumnClick"
                @pageChange="pageChange"
            />
            <div class="delete-text-similar" @click="deleteSimilar" v-show="data.id">
                <Icon :width="16" :height="18" bgPosition="-96px 0" hoverBgPosition="-96px -22px" class="link-delete-icon" />
                {{ deleteLabel }}
            </div>
            <div class="text-similar-ques-button">
                <RoundButton :text="cancelLabel" @btnClick="cancelClick" :cls="cancelCls" />
                <RoundButton
                    :text="confirmLabel"
                    :cls="confirmCls"
                    :class="{ 'prohibit-submit': confirmCls == 'cancel-btn' }"
                    @btnClick="confirmClick"
                />
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import RelationQuesBar from "./RelationQuesBar.vue";
import Table from "@/views/zhiji/bComponents/newTable/Table.vue";
import { searchSimilarQuesList } from "./similarQuesConfig.js";
export default {
    name: "QuestionSelectorTableModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton,
        RelationQuesBar,
        Table,
        Icon
    },
    data() {
        return {
            linkedQuestionId: "",
            standTotal: "",
            tableData: [],
            searchKeyWordObj: {},
            categorizeList: [],
            curPage: 1,
            curPageLen: 10,
            cancelCls: "cancel-btn",
            selectedQues: {},
            searchReset: { questionType: "stand", questionId: parseInt(this.data.questionId) || "" },
            maxLevel: 3,
            initQuestion: parseInt(this.data.questionId),
            currentLang: this.data.currentLang || ""
        };
    },
    computed: {
        dataSource() {
            this.tableData.map(item => {
                if (item.rowId === this.linkedQuestionId) {
                    item.radio = true;
                }
            })
            return this.tableData;
        },
        wordLabel() {
            return this.$t("zhiji.answer.textWidget.selectedText");
        },
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        confirmCls() {
            return this.linkedQuestionId ? "confirm-btn" : "cancel-btn";
        },
        tableConfig() {
            return searchSimilarQuesList();
        },
        deleteLabel() {
            return this.$t("zhiji.answer.textWidget.deletLink");
        }
    },
    created() {
        if (this.initQuestion) {
            this.searchReset.questionType = "questionId";
            !this.data.langDisabled && (this.currentLang = "all");
        }
    },
    async mounted() {
        // 获取分类列表
        this.categorizeList = await this.zhiji.requestByServiceName("getTreesData");
        this.categorizeList.map(firstItem => {
            firstItem.completeArr = [];
            firstItem.firstName = firstItem.label;
            firstItem.children.length > 0 &&
                firstItem.children.forEach(secondItem => {
                    firstItem.completeArr.push({
                        completeName: `${firstItem.label} > ${secondItem.label}`,
                        setId: parseInt(secondItem.id),
                        firstName: firstItem.label,
                        secondName: secondItem.label
                    });
                    if (secondItem.children.length > 0) {
                        secondItem.completeArr = [];
                        this.recursionSearchSort(secondItem.children, secondItem.completeArr);
                    }
                });
        });
        this.selectedQues = this.data;
        this.initIsExist();
        this.getCurrLangRes();
    },
    methods: {
        getCurrLangRes() {
            !this.initQuestion && this.currentLang && this.getLinkedQuestionList({ page: 1 });
        },
        // 已有关联问题
        initIsExist() {
            if (this.initQuestion) {
              this.linkedQuestionId = this.initQuestion;
              this.zhiji.requestByServiceName("queryQuestionList", {
                field: this.initQuestion,
                page:1,
                size:10,
                type: "questionId"
              }).then(res => {
                this.addClassifyHandle(res);
              });
            }
        },
        // 递归处理分类列表数据
        recursionSearchSort(data, needArr) {
            if (!data.length) {
                return [];
            }
            data.forEach(item => {
                needArr.push({ setId: parseInt(item.id) });
                item.children ? this.recursionSearchSort(item.children, (item.completeArr = [])) : [];
            });
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        initCurrPage() {
            this.curPage = 1;
        },
        confirmClick() {
            if (!this.linkedQuestionId) {
              return;
            } else {
                this.data.confirm &&
                    this.data.confirm({
                        id: this.data.id || "",
                        type: this.data.id ? "update" : "add",
                        word: this.data.word,
                        wordColor: this.data.wordColor,
                        questionData: this.selectedQues,
                        ...this.selectedQues
                    });
            }
            this.close();
        },
        // 抽取重复的赋值操作
        extractAssign(tableItem, completeItem, unknown) {
            tableItem.categorize = unknown ? `unknown > ${completeItem.label}` : completeItem.completeName;
            tableItem.firstName = unknown || completeItem.firstName;
            tableItem.secondName = completeItem.secondName;
            tableItem.isFinish = true;
        },
        // 将搜索到的数据拼上分类
        addClassifyHandle(res) {
            res.dataset.map(tableItem => {
                this.categorizeList.forEach(item => {
                    if (parseInt(item.id) === tableItem.categorizeId) {
                        this.extractAssign(tableItem, item, "unknown");
                        return;
                    }
                    item.children.length > 0 &&
                    item.completeArr.forEach((completeItem, idx) => {
                        if (tableItem.categorizeId === completeItem.setId) {
                            this.extractAssign(tableItem, completeItem);
                            return;
                        }
                        if (item.children[idx].children.length > 0 && !tableItem.isFinish) {
                            let deepId = this.recursionTableData(item.children[idx], tableItem);
                            deepId ? (completeItem.setId = deepId) : null;
                            this.extractAssign(tableItem, completeItem);
                            return;
                        }
                    });
                });
            });
            this.tableData = res.dataset;
            this.standTotal = res.standTotal;
        },
        // 搜索的方法
        getLinkedQuestionList(data) {
            // 合并请求参数
            this.searchKeyWordObj = Object.assign({}, { size: 10, lang: this.currentLang }, this.searchKeyWordObj, data);
            this.zhiji.requestByServiceName("queryQuestionList", this.searchKeyWordObj).then(res => {
                this.addClassifyHandle(res);
            });
        },
        // 递归处理表格数据
        recursionTableData(data, tableSearchData) {
            if (!data.children.length) {
                return [];
            }
            let setId = "";
            data.completeArr.forEach(item => {
                if (item.setId === tableSearchData.categorizeId) {
                    setId = item.setId;
                    return;
                } else if (item.children) {
                    this.recursionTableData(item.children, tableSearchData);
                }
            });
            return setId;
        },
        tableColumnClick(data) {
            this.linkedQuestionId = data.rowData.rowId;
            this.tableData.find(item => {
                if (item.questionId == data.rowData.rowId) {
                    this.selectedQues.categorize = `{${item.categorize}}`;
                    this.selectedQues.optionTip = item.optionTip;
                    this.selectedQues.question = item.question;
                    this.selectedQues.questionId = item.questionId;
                    this.selectedQues.sceneLevel1 = item.firstName;
                    this.selectedQues.sceneLevel2 = item.secondName;
                }
            });
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getLinkedQuestionList({
                page: data.curPage,
                size: data.pageLength
            });
        },
        // 删除已关联的问题
        deleteSimilar() {
            this.data.confirm &&
                this.data.confirm({
                    id: this.data.id || "",
                    type: "delete",
                    wordColor: this.data.wordColor,
                    questionData: this.selectedQues,
                    word: this.data.word
                });
            this.close();
        }
    }
};
</script>
<style lang="less" scoped>
.text-similar-ques-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .text-similar-ques-box {
        width: 50vw;
        max-height: 86vh;
        .text-editor-select-title {
            margin-bottom: 15px;
            .text-editor-select-text {
                display: inline-block;
                max-width: calc(100% - 100px);
                vertical-align: -6px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-left: 10px;
                padding: 5px 12px;
                background-color: rgba(208, 224, 231, 0.3);
            }
        }
        /deep/.opeat-r {
            margin-bottom: 10px;
        }
        .delete-text-similar {
            cursor: pointer;
            text-decoration: underline;

            .link-delete-icon {
                vertical-align: -3px;
            }
            &:hover {
                color: #2ec2ff;
                .link-delete-icon {
                    background-position: -96px -22px !important;
                }
            }
        }
        /deep/.header-wrapper th:last-child {
            padding: 14px 10px 15px 10px;
        }
        a,a:link,a:visited,a:hover,a:active{
            text-decoration: none;
            color:inherit;
        }
    }
    .text-similar-ques-button {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        .cancel-btn {
            background: #fff;
            &:hover {
                color: rgba(65, 71, 94, 0.9) !important;
            }
        }
        .prohibit-submit {
            cursor: not-allowed;
        }
    }
}
/deep/.el-table__header,
/deep/.el-table__body {
    width: 100% !important;
}
/deep/ .table-header-space {
    font-size: 14px;
}
</style>
